import type { ProjectPlanInputs } from "./capitalPlan";
import type { ProjectFundingReview } from "../domain/fundingProject";
import type { ScenarioProject } from "../domain/financing";

/** Forecast overlays cannot change an actual closing or any stored underwriting. */
export function applyFundingProjectReview(input:ProjectPlanInputs,review:ProjectFundingReview|undefined){
  const result={...input};const issues:string[]=[];
  if(!review||input.sale?.closedAt)return {inputs:result,issues};
  if(review.expectedClosingDate){result.expectedExitDate=review.expectedClosingDate;result.sale=null;}
  if(review.expectedSaleCents!==undefined&&review.expectedSaleCents!==null){
    if(review.sellingCostPctX100===null||review.sellingCostPctX100===undefined)issues.push(`${input.subject.name}: confirm selling costs before using a new sale-price assumption.`);
    else result.expectedArvCents=review.expectedSaleCents-Number((BigInt(review.expectedSaleCents)*BigInt(review.sellingCostPctX100)+5000n)/10000n);
  }else if(review.sellingCostPctX100!==null&&review.sellingCostPctX100!==undefined)issues.push(`${input.subject.name}: selling-cost overlay needs an explicit gross sale-price assumption.`);
  return {inputs:result,issues};
}
export function scenarioFundingDefaults(source:ScenarioProject){
  const price=source.purchasePriceCents,down=source.downPaymentCents;
  // Do not silently round an existing exact down payment into a different acquisition requirement.
  const exactPct=price&&down!==null&&BigInt(down)*10000n%BigInt(price)===0n?Number(BigInt(down)*10000n/BigInt(price)):null;
  return {...source,downPaymentPctX100:exactPct};
}
